exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-primary[data-v-55a8f781] {\n    width: 70px;\n}\n.btn-outline-primary[data-v-55a8f781] {\n    width: 70px;\n}\n#content[data-v-55a8f781] {\n    white-space: pre-wrap;\n    word-wrap: break-word;\n}\n", ""]);

// exports
